import {DetailsPageAppProps} from '../../../../app/interfaces'
import {connect} from '../../../../runtime-context/context'
import {SidebarOwnProps, SidebarRuntimeProps} from './interfaces'
import {Sidebar as Presentation} from './sidebar'

const mapRuntime = ({state}: DetailsPageAppProps): SidebarRuntimeProps => ({
  showAccessibilityMode: state.seating.showAccessibilityMode,
})

export const Sidebar = connect<SidebarOwnProps, SidebarRuntimeProps>(mapRuntime)(Presentation)
export * from './interfaces'
